import { QueryClient } from '@tanstack/react-query';

/**
 * Events sent while the socket was down are not replayed (unless the server's connection state
 * recovery did it, which `recovered` reports), so every connect after the first resyncs all
 * queries rather than leaving the UI on what it had before the drop. Covers both automatic
 * reconnection and the manual `connect()` after a server-initiated disconnect.
 */
export const resyncOnReconnect = (queryClient: QueryClient) => {
  let hasConnected = false;
  return (recovered: boolean) => {
    if (hasConnected && !recovered) {
      queryClient.invalidateQueries();
    }
    hasConnected = true;
  };
};
